// extracted by mini-css-extract-plugin
export default {"wrapper":"absLoader_wrapper__+ow8-","loader":"absLoader_loader__AwjxC","sm":"absLoader_sm__vtqUi","md":"absLoader_md__9r1iM","defaultSize":"absLoader_defaultSize__Q4MRC"};